import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=54dc8dc5&scoped=true&"
import script from "./DataForm.vue?vue&type=script&lang=js&"
export * from "./DataForm.vue?vue&type=script&lang=js&"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=54dc8dc5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dc8dc5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54dc8dc5')) {
      api.createRecord('54dc8dc5', component.options)
    } else {
      api.reload('54dc8dc5', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=54dc8dc5&scoped=true&", function () {
      api.rerender('54dc8dc5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/DataForm.vue"
export default component.exports